import { createSlice } from "@reduxjs/toolkit";

const initialTemplate = {
    items: []
}
const slice = createSlice({
    name: 'template',
    initialState: initialTemplate,
    reducers: {
        setItem: (state, action) => {
            let { itemTemplate = [] } = action.payload
            state.items = itemTemplate
        },
        addItem: (state, action) => {
            let { itemTemplate = [] } = action.payload;
            state.items = [...state.items, ...itemTemplate]
        },
        updateItem: (state, action) => {
            let { itemTemplate = [] } = action.payload;
            const data = state.items.map(item => {
                const _item = itemTemplate.find(temp => temp.id === item.id);
                if (_item) return _item
                else return item;
            });
            state.items = data
        },
        deleteItem: (state, action) => {
            let { id = '' } = action.payload;
            const data = state.items.filter(item => item.id !== id)
            if (id) state.items = data
        },
        clearItems: (state) => {
            state.items = [];
        }
    }
})

export default slice.reducer

export const { setItem, updateItem, deleteItem, addItem, clearItems } = slice.actions

export const setItemTemplate = (data) => async dispatch => {
    try {
        dispatch(setItem({ itemTemplate: data }))
    } catch (error) {
        console.error(error)
    }
}

export const updateItemTemplate = (data) => async dispatch => {
    try {
        dispatch(updateItem({ itemTemplate: data }))
    } catch (error) {
        console.error(error)
    }
}
export const newItemTemplate = (data) => async dispatch => {
    try {
        dispatch(addItem({ itemTemplate: [data] }))
    } catch (error) {
        console.error(error)
    }
}

export const destroyItemTemplate = (data) => async dispatch => {
    try {
        dispatch(deleteItem({ id: data }))
    } catch (error) {
        console.error(error)
    }
}

export const clearItemsTemplate = (data) => async dispatch => {
    try {
        dispatch(clearItems())
    } catch (error) {
        console.error(error)
    }
} 